import React from 'react';
import { Truck, LogIn, LogOut, Clock, Activity } from 'lucide-react';
import { KPICard } from './ui/KPICard';
import { Badge } from './ui/Badge';
import { AreaChart, Area, ResponsiveContainer } from 'recharts';
const sparklineData = [{
  v: 10
}, {
  v: 15
}, {
  v: 35
}, {
  v: 20
}, {
  v: 45
}, {
  v: 30
}, {
  v: 50
}, {
  v: 45
}, {
  v: 60
}];
export function KPISection() {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-294">
      {/* 1. Trucks Inside */}
      <KPICard title="Trucks Inside" value="42" icon={<Truck className="h-4 w-4" data-id="element-296" />} subValue={<div className="flex gap-2" data-id="element-297">
            <Badge variant="neutral" className="text-[10px] px-1.5" data-id="element-298">
              12 Small
            </Badge>
            <Badge variant="neutral" className="text-[10px] px-1.5" data-id="element-299">
              24 Large
            </Badge>
            <Badge variant="neutral" className="text-[10px] px-1.5" data-id="element-300">
              6 Trailer
            </Badge>
          </div>} data-id="element-295" />

      {/* 2. Entries */}
      <KPICard title="Entries (Today)" value="128" trend={{
      value: 12,
      direction: 'up'
    }} icon={<LogIn className="h-4 w-4" data-id="element-302" />} subValue={<span className="text-xs text-gray-500" data-id="element-303">Last entry 2m ago</span>} data-id="element-301" />

      {/* 3. Exits */}
      <KPICard title="Exits (Today)" value="94" trend={{
      value: 5,
      direction: 'up'
    }} icon={<LogOut className="h-4 w-4" data-id="element-305" />} subValue={<span className="text-xs text-gray-500" data-id="element-306">Last exit 8m ago</span>} data-id="element-304" />

      {/* 4. SLA Risk */}
      <KPICard title="SLA Risk (>4h)" value="3" alertLevel="critical" icon={<Clock className="h-4 w-4" data-id="element-308" />} subValue={<div className="flex items-center justify-between text-xs" data-id="element-309">
            <span className="text-red-400 font-medium" data-id="element-310">3 Overdue</span>
            <span className="text-amber-400 font-medium" data-id="element-311">5 Approaching</span>
          </div>} data-id="element-307" />

      {/* 5. Congestion */}
      <KPICard title="Gate Congestion" value="Medium" icon={<Activity className="h-4 w-4" data-id="element-313" />} subValue={<div className="h-8 w-full" data-id="element-314">
            <ResponsiveContainer width="100%" height="100%" data-id="element-315">
              <AreaChart data={sparklineData} data-id="element-316">
                <Area type="monotone" dataKey="v" stroke="#f59e0b" fill="#f59e0b" fillOpacity={0.1} strokeWidth={2} data-id="element-317" />
              </AreaChart>
            </ResponsiveContainer>
          </div>} data-id="element-312" />
    </div>;
}